import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import {
  Title,
  SpinnerContainer,
  ButtonContainer,
  ViewsContainer,
} from "../../ui/BaseComponents";
import { Spinner, Stack } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import CreateServiceType from "../create/CreateServiceType";
import DeleteServiceType from "../delete/DeleteServiceTypes";
import UpdateServiceType from "../update/UpdateServiceTypes";
import { ContentHeader } from "../../ui/BaseComponents";
import axios from "axios";

export default function ViewServiceProviders({ service }) {
  const [fetchedData, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // GET
  const fetchData = async () => {
    try {
      const { data } = await axios(
        `https://ea1-dev.azurewebsites.net/api/userServiceProviderServices/${service.id}/providers`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setData(data);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      alert("error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container fluid style={{ margin: 10 }}>
      {isLoading ? (
        <SpinnerContainer>
          <Spinner animation='grow' variant='danger' />
          <Spinner animation='grow' variant='danger' />
          <Spinner animation='grow' variant='danger' />
        </SpinnerContainer>
      ) : (
        <Stack>
          <ContentHeader>{`${service.name} Service Providers`}</ContentHeader>
          <ViewsContainer style={{ padding: "1em", margin: "0 2%" }}>
            <Table hover borderless>
              <thead>
                <tr
                  style={{
                    borderBottom: "2px solid rgba(0, 0, 0, 0.29)",
                    color: "#292929",
                  }}
                >
                  <th>Name</th>
                  <th>Max Price</th>
                  <th>Min Price</th>
                  <th>email</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: "1.4em" }}>
                {fetchedData.map((item: any, i) => (
                  <tr
                    key={i}
                    style={
                      i % 2 === 0
                        ? {
                            borderBottom: ".02em solid rgba(0, 0, 0, 0.19)",
                            backgroundColor: "#D8ECFD",
                            color: "#292929",
                          }
                        : {
                            borderBottom: ".02em solid rgba(0, 0, 0, 0.19)",
                            backgroundColor: "#ECF3FE",
                            color: "#292929",
                          }
                    }
                  >
                    <td>{`${item.first_name} ${item.last_name}`}</td>
                    <td style={{ color: "green" }}>{`$ ${item.max_price}`}</td>
                    <td style={{ color: "green" }}>{`$ ${item.min_price}`}</td>
                    <td>
                      <a href={`mailto:${item.email}`}>{item.email}</a>{" "}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ViewsContainer>
        </Stack>
      )}
    </Container>
  );
}
